module.exports = __webpack_public_path__ + "static/media/1.51865ba4.jpg";